import React from 'react';
import { SparklesTrend } from './Sparkles';
import './Sparkles.scss';

/** Scatter of small sparks across the parent's top band (a card header). The parent must be `position: relative`. */
const SparklesField: React.FC<{ trend?: SparklesTrend }> = ({ trend = 'neutral' }) => (
  <span className={`sparkles-field${trend === 'neutral' ? '' : ` sparkles-field--${trend}`}`} aria-hidden="true">
    {Array.from({ length: 12 }, (_, i) => (
      <span key={i} className="sparkles-field__spark" />
    ))}
  </span>
);

export default SparklesField;
